function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgHealthPanel = function SvgHealthPanel(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    d: "M12.68 3.893v.965H4.964v-.965z"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "M13.645.518a.483.483 0 0 1 0 .964H4a.483.483 0 0 1 0-.964z"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "M4.482 19.325V1a.483.483 0 0 1 .965 0v18.325a3.376 3.376 0 0 0 6.75 0v-2.48a.482.482 0 0 1 .966 0v2.48a4.34 4.34 0 0 1-8.681 0m7.716-13.571V1a.483.483 0 0 1 .965 0v4.754a.482.482 0 0 1-.965 0"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "M7.603 6.59a.483.483 0 0 1 0 .965H5.674a.483.483 0 0 1 0-.965zM7.603 9.68a.483.483 0 0 1 0 .965H5.674a.483.483 0 0 1 0-.965zM7.603 12.574a.483.483 0 0 1 0 .965H5.674a.483.483 0 0 1 0-.965zM7.603 15.467a.483.483 0 0 1 0 .965H5.674a.483.483 0 0 1 0-.965zM17.189 8.837a3.799 3.799 0 1 0-5.803 4.903 3.799 3.799 0 0 0 5.803-4.903m.737-.622a4.763 4.763 0 1 1-7.277 6.148 4.763 4.763 0 0 1 7.277-6.148"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeLinecap: "round",
    strokeWidth: 0.964,
    d: "m17.102 15.16 3.074 3.638"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    d: "M13.814 8.65a.624.624 0 0 1 1.021.07l1.267 2.11a2.16 2.16 0 0 1-.252 2.551 2.083 2.083 0 0 1-3.1 0c-.63-.7-.74-1.738-.252-2.55l1.267-2.11zm-.458 2.695c-.258.43-.203.99.137 1.367a1.084 1.084 0 0 0 1.613 0c.34-.378.396-.937.138-1.367L14.3 9.772z"
  }));
};
export default SvgHealthPanel;